<template>
    <footer id="bottom" class="relative footer_z_index">
        <div id="footer-1" style="overflow: hidden;">
            <div class="center">
                <div class="footer-blok width20 paddingtop20 paddingbottom20">
                    <span class="header6 orange">Rederijen</span>
                    <ul>
                        <li><a href="/rederij/aida-cruises">AIDA Cruise</a></li>
                        <li><a href="/rederij/azamara">Azamara Cruise</a></li>
                        <li>
                            <a href="/rederij/carnival-cruise-lines"
                                >Carnival Cruise</a
                            >
                        </li>
                        <li>
                            <a href="/rederij/celebrity">Celebrity Cruise</a>
                        </li>
                        <li>
                            <a href="/rederij/costa-cruises">Costa Cruises</a>
                        </li>
                        <li>
                            <a href="/rederij/crystal-cruises"
                                >Crystal Cruises</a
                            >
                        </li>
                        <li>
                            <a href="/rederij/disney-cruise-line"
                                ><i>Disney Cruise Line</i></a
                            >
                        </li>
                        <li>
                            <a href="/rederij/hapag-lloyd-cruises"
                                >Hapag-Lloyd Cruise</a
                            >
                        </li>
                        <li>
                            <a href="/rederij/holland-america-line"
                                >Holland America Line</a
                            >
                        </li>
                        <li><a href="/rederij/msc-cruises">MSC Cruises</a></li>
                        <li>
                            <a href="/rederij/norwegian-cruise-line"
                                >Norwegian Cruise</a
                            >
                        </li>
                        <li>
                            <a href="/rederij/oceania-cruises"
                                >Oceania Cruises</a
                            >
                        </li>
                        <li>
                            <a href="/rederij/ponant-yacht-cruises"
                                >Ponant Yacht Cruises</a
                            >
                        </li>
                        <li>
                            <a href="/rederij/princess-cruises"
                                >Princess Cruises</a
                            >
                        </li>
                        <li>
                            <a href="/rederij/regent-seven-seas-cruises"
                                >Regent Seven Seas Cruises</a
                            >
                        </li>
                        <li>
                            <a href="/rederij/royal-caribbean"
                                >Royal Caribbean Cruise</a
                            >
                        </li>
                        <li><a href="/rederij/seabourn">Seabourn Cruise</a></li>
                        <li>
                            <a href="/rederij/seadream-yacht-club"
                                >SeaDream Yacht Club</a
                            >
                        </li>
                        <li>
                            <a href="/rederij/silversea-cruises"
                                >Silversea Cruises</a
                            >
                        </li>
                        <li>
                            <a href="/rederij/star-clippers">Star Clippers</a>
                        </li>
                    </ul>
                </div>
                <div class="footer-blok width20 paddingtop20 paddingbottom20">
                    <span class="header6 orange">Bestemmingen</span>
                    <ul>
                        <li><a href="/bestemming/afrika">Afrika</a></li>
                        <li><a href="/bestemming/alaska">Alaska</a></li>
                        <li><a href="/bestemming/azie">Azië</a></li>
                        <li>
                            <a href="/bestemming/caribbean-midden-amerika"
                                >Caribbean &amp; Midden-Amerika</a
                            >
                        </li>
                        <li>
                            <a href="/bestemming/dubai-emiraten"
                                >Dubai &amp; Emiraten</a
                            >
                        </li>
                        <li>
                            <a href="/bestemming/middellandsezee"
                                >Middellandse Zee</a
                            >
                        </li>
                        <li>
                            <a href="/bestemming/noord-amerika"
                                >Noord-Amerika</a
                            >
                        </li>
                        <li>
                            <a href="/bestemming/noord-europa">Noord-Europa</a>
                        </li>
                        <li><a href="/bestemming/oceanie">Oceanie</a></li>
                        <li>
                            <a href="/bestemming/panamakanaal">Panamakanaal</a>
                        </li>
                        <li>
                            <a href="/bestemming/transatlantisch"
                                >Transatlantisch</a
                            >
                        </li>
                        <li>
                            <a href="/bestemming/wereldcruise-grandvoyages"
                                >Wereldcruise &amp; Grand Voyages</a
                            >
                        </li>
                        <li>
                            <a href="/bestemming/westkust-vs">Westkust VS</a>
                        </li>
                        <li>
                            <a href="/bestemming/zuid-amerika">Zuid-Amerika</a>
                        </li>
                    </ul>
                </div>
                <div class="footer-blok width20 paddingtop20 paddingbottom20">
                    <span class="header6 orange">Service</span>
                    <ul>
                        <li><a href="/contact">Contact</a></li>
                        <li>
                            <a href="/veelgestelde-vragen"
                                >Veelgestelde vragen</a
                            >
                        </li>
                        <li><a href="/klantenservice">Klantenservice</a></li>
                        <li><a href="/verzekeringen">Verzekeringen</a></li>
                        <li><a href="/groepsreizen">Groepsreizen</a></li>
                        <li>
                            <a href="/zakelijke-reizen">Zakelijke reizen</a>
                        </li>
                        <li><a href="/betalen">Betaling voldoen</a></li>
                        <li>
                            <a href="/laagsteprijsgarantie"
                                >Spelregels laagsteprijsgarantie</a
                            >
                        </li>
                    </ul>

                    <div class="width100 paddingtop20 paddingbottom20">
                        <span class="header6 orange">Over CruiseReizen.nl</span>
                        <ul>
                            <li>
                                <a href="/over-cruisereizen-nl"
                                    >Over CruiseReizen.nl</a
                                >
                            </li>
                            <li><a href="/vipclub">VIP Club</a></li>
                            <li><a href="/tv">CruiseReizen TV</a></li>
                            <li>
                                <a href="/media">Media / bannermateriaal</a>
                            </li>
                            <li><a href="/vacatures">Vacatures</a></li>
                            <li>
                                <a href="/missie-strategie-visie-geschiedenis">
                                    Missie, visie, strategie &amp; geschiedenis
                                </a>
                            </li>
                            <!-- @todo cookiebar
                            <li>
                                <a onclick="$('.divcookieinfo').slideUp();$('.divcookieaanpassen').slideToggle();"
                                   style="cursor: pointer;">Cookies aanpassen</a>
                            </li>
                            -->
                        </ul>
                    </div>
                </div>

                <div class="footer-blok width20 paddingtop20 paddingbottom20">
                    <span class="header6 orange">Direct advies</span>
                    <ul>
                        <li>
                            <b>Openingstijden</b><br />
                            Ma - vr: 09:00 - 20:00<br />
                            Za - zo: 10:00 - 18:00<br />
                            Bel voor persoonlijk advies <br />
                            <a href="tel010-7200 500">010-7200500</a>
                        </li>
                    </ul>
                </div>

                <div class="footer-blok width20 paddingtop20">
                    <CruiseSpecialist />
                </div>
            </div>
        </div>
        <div class="clear"></div>

        <!-- footer mobile -->
        <div id="footer-2">
            <div class="center">
                <!-- @todo escape mobile
                <div class="mobile">
                    <a id="escapeMobile" class="button clear orangebg width100">Bekijk desktop versie</a>
                </div>
                -->

                <div
                    id="footer-2-content"
                    class="width100 paddingtop10 paddingbottom10"
                >
                    <div class="footer2content">
                        <div class="d-flex footer-wrapper">
                            <div class="footer-item-logo">
                                <span
                                    class="height30 margin5 logosmall-img"
                                ></span>
                                © 2013-2019 CruiseReizen BV
                            </div>
                            <div class="d-flex footer-item-menu">
                                <a class="margin5" href="/disclaimer"
                                    >Disclaimer</a
                                >
                                <a
                                    class="margin5"
                                    href="/privacy"
                                    style="margin-left: 25px;"
                                    >Privacy</a
                                >
                                <a class="margin5" href="/algemene-voorwaarden"
                                    >Algemene Voorwaarden</a
                                >
                            </div>
                            <div class="d-flex footer-item-images">
                                <div class="importantimages">
                                    <span
                                        class="floatleft height30 margin5 fd-img"
                                    ></span>
                                </div>
                                <div class="betaalmethodes">
                                    <span
                                        class="floatleft margin5 ideal-img"
                                    ></span>
                                    <span
                                        class="floatleft margin5 paypal-img"
                                    ></span>
                                    <span
                                        class="floatleft margin5 mrcash-img"
                                    ></span>
                                    <span
                                        class="floatleft margin5 visa-img"
                                    ></span>
                                    <span
                                        class="floatleft margin5 master-img"
                                    ></span>
                                    <span
                                        class="floatleft margin5 amex-img"
                                    ></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import CruiseSpecialist from './CruiseSpecialist.vue'

export default {
    name: 'Footer2',
    components: {
        CruiseSpecialist,
    },
}
</script>

<style scoped>
.footer_z_index {
    z-index: -1000;
}
</style>
